import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import "../assets/css/style.css";
import bannerImage from "../assets/img/ban1.jpg";
import dummylogo from "../assets/img/dummy-logo.png";
import dummyimage from "../assets/img/dummyimage.png";
import linkedin_icon from "../assets/img/skill-icons_linkedin.svg";
import instagram_icon from "../assets/img/skill-icons_instagram.svg";
import facebook_icon from "../assets/img/logos_facebook.svg";
// Placeholder imports for empfeedback images
import empsatis from "../assets/img/empsatis.png";
import compcul from "../assets/img/compcul.png";
import easywork from "../assets/img/easywork.png";
import wlifebalac from "../assets/img/wlifebalac.png";
import topmang from "../assets/img/topmang.png";
import hrattitude from "../assets/img/hrattitude.png";
import ceorank from "../assets/img/ceorank.png";

const CompanyProfile = () => {
  const { company_id } = useParams();
  const [companyData, setCompanyData] = useState(null);
  const [answers, setAnswers] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        // Fetch company details using POST request
        const companyResponse = await axios.post(
          "http://localhost:5000/api/company/data",
          { company_id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const companyDetails = companyResponse.data?.companyDetails || [];
        const matchedCompany = companyDetails.result.find(
          (company) => String(company.company_id) === String(company_id)
        );
        // Set the company and answers data
        setCompanyData(matchedCompany || null);
        setAnswers(matchedCompany.answers);
        console.log(matchedCompany.answers);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [company_id]);

  // if (loading) {
  //   return <div className="dataloading ft-16 fw-600 text-center">Loading...</div>;
  // }

  return (
    <div id="wrapper">
      <section
        id="banner"
        style={{
          minHeight: "480px",
          background: `url(${bannerImage}) center left no-repeat`,
          backgroundSize: "cover",
        }}
        className="d-flex py-5"
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-7 mx-auto pt-5">
              <div className="text-center pt-5">

                {companyData ? (
                  <>
                    <h1 className="text-white display2 mb-3 fw-700">
                      {companyData?.company_name}
                    </h1>
                    <h4 className="fw-400 text-white cbcbcb lh-26">
                      {companyData?.description || "Company description goes here..."}
                    </h4>
                </>
                ) : (
                  <p className="text-white">Company Data Not Available</p>
                )}

              </div>
            </div>
          </div>
        </div>
      </section>


      <section id="inner_section">
        <div className="container">

          {loading ? (
            <div className="dataloading ft-16 fw-600 text-center py-5">
              <i class="fa fa-spinner fa-spin white loadingicon"></i>
              {/* Loading content... */}
            </div>
          ) : (
              <div className="row">
                {/* Left Sidebar */}
                <div className="col-lg-4 col-xl-4">
                  <aside id="asidebar_inner" className="ft-15 lh-22">
                    <div className="first_box card_box">
                      <div className="user-info mb-0 d-flex align-items-center">
                        <img src={dummylogo} alt="User" />
                        <div className="ms-2">
                          <div className="name">{companyData?.company_name}</div>
                          <div className="time">
                            {companyData?.company_url ? (
                              <a
                                href={
                                  companyData.company_url.startsWith("http")
                                    ? companyData.company_url
                                    : `https://${companyData.company_url}`
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {companyData.company_url}
                              </a>
                            ) : (
                              "NA"
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card_box color-555 mt-3">
                      <table className="table info-table">
                        <tbody>
                          <tr>
                            <td className="info-title">Publically Known As</td>
                            <td className="info-content">
                              {companyData?.company_name || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td className="info-title">Year Of Establishment</td>
                            <td className="info-content">
                              {companyData?.answers?.find(
                                (ans) => ans.question_id === 41
                              )?.answer || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td className="info-title">Headquarter</td>
                            <td className="info-content">
                              {companyData?.answers?.filter(
                                (ans) => ans.question_id === 40
                              )?.[1]?.answer || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td className="info-title">Post code</td>
                            <td className="info-content">
                              {companyData?.answers?.filter(
                                (ans) => ans.question_id === 40
                              )?.[4]?.answer || "NA"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="divider"></div>
                      <table className="table info-table">
                        <tbody>
                          <tr>
                            <td className="info-title">CEO</td>
                            <td className="info-content">
                              {companyData?.answers?.find(
                                (ans) => ans.question_id === 47
                              )?.answer || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td className="info-title">CEO LinkedIn profile</td>
                            <td className="info-content">
                              {(() => {
                                const ceoLinkedIn = companyData?.answers?.find(
                                  (ans) => ans.question_id === 117
                                )?.answer;
                                if (!ceoLinkedIn) return "NA";
                                const displayText =
                                  ceoLinkedIn.length > 15
                                    ? ceoLinkedIn.slice(0, 15) + "..."
                                    : ceoLinkedIn;
                                return (
                                  <a
                                    href={ceoLinkedIn}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={ceoLinkedIn}
                                  >
                                    {displayText}
                                  </a>
                                );
                              })()}
                            </td>
                          </tr>
                          <tr>
                            <td className="info-title">Parent Company</td>
                            <td className="info-content">
                              {companyData?.answers?.find(
                                (ans) => ans.question_id === 35
                              )?.answer || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td className="info-title">Parent Company URL</td>
                            <td className="info-content">
                              {(() => {
                                const parentCompanyURL = companyData?.answers?.find(
                                  (ans) => ans.question_id === 36
                                )?.answer;
                                if (!parentCompanyURL || parentCompanyURL === "NA")
                                  return "NA";
                                return (
                                  <a
                                    href={parentCompanyURL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {parentCompanyURL}
                                  </a>
                                );
                              })()}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div className="divider"></div>
                      <h5 className="ft-15 fw-700 mb-3">
                        <i className="bi bi-file-text ft-20 me-2"></i> Custom
                        Information
                      </h5>
                      <table className="table info-table">
                        <tbody>
                          <tr>
                            <td className="info-title">Company Age</td>
                            <td
                              className="info-content"
                              style={{ width: "140px" }}
                            >
                              {companyData?.company_age || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td className="info-title">Sector</td>
                            <td className="info-content">
                              {companyData?.answers?.find(
                                (ans) => ans.question_id === 43
                              )?.answer || "NA"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </aside>
                </div>
                {/* Right Content */}
                <div className="col-lg-8">
                  <div className="inner_wrapper card_box py-5">
                    <ul className="nav nav-tabs justify-content-between fw-600 border-0">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-bs-toggle="tab"
                          href="#aboutpeople"
                        >
                          About {companyData?.company_name}
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#Employee"
                        >
                          Employee
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#seoinsights"
                        >
                          Seo Insights Section
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#empfeedback"
                        >
                          Employees Feedback
                        </a>
                      </li>
                    </ul>

                    {/* Answers Section */}
                    <div className="tab-content pt-3">
                      <div className="tab-pane fade show active" id="aboutpeople">
                        <div className="content">
                          <p>
                            {companyData?.answers?.find(
                              (ans) => ans.question_id === 37
                            )?.answer || "NA"}
                          </p>
                          <div className="contactinfo mt-5">
                            <h5 className="ft-15 fw-700">
                              <i className="bi bi-person ft-20"></i> Contact
                              Information
                            </h5>
                            <div className="row mt-3 ft-13 lh-20">
                              <div className="col-md-4 mb-3">
                                <div className="contact-box d-flex align-items-center gap-3">
                                  <i className="bi bi-geo-alt ft-18"></i>
                                  <span>
                                    {companyData?.answers
                                      ?.filter((ans) => ans.question_id === 40)
                                      ?.filter((_, index) => index !== 2 && index !== 3)
                                      ?.map((ans) => ans.answer)
                                      ?.join(", ") || "NA"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-4 mb-3">
                                <div className="contact-box d-flex align-items-center gap-3">
                                  <i className="bi bi-telephone ft-18"></i>
                                  <span>
                                    {companyData?.answers?.filter(
                                      (ans) => ans.question_id === 40
                                    )?.[2]?.answer || "NA"}
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-4 mb-3">
                                <div className="contact-box d-flex align-items-center gap-3">
                                  <i className="bi bi-envelope ft-18"></i>
                                  <span>
                                    {companyData?.answers?.filter(
                                      (ans) => ans.question_id === 40
                                    )?.[3]?.answer || "NA"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="Employee">
                        <div className="container-fluid px-0">
                          <div className="team-info pb-3">
                            <div>
                              <div className="ttitle fw-bold">
                                Meet the Clonify team
                              </div>
                              <div className="teamsummary">
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the
                                industry's standard dummy text ever since the 1500s,
                              </div>
                            </div>
                          </div>
                          <div className="row g-4">
                            {[...Array(8)].map((_, idx) => (
                              <div className="col-md-4 col-lg-3" key={idx}>
                                <div className="team-card">
                                  <img src={dummyimage} alt="Dummy Image" />
                                  <h5 className="mt-2">Jocelyn Schleifer</h5>
                                  <p className="text-muted">Software Engineer</p>
                                  <p className="text-muted">
                                    There are many variations of passages of text.
                                  </p>
                                  <div className="icons mt-3">
                                    <a href="#">
                                      <img src={facebook_icon} alt="Facebook" />
                                    </a>
                                    <a href="#">
                                      <img src={instagram_icon} alt="Instagram" />
                                    </a>
                                    <a href="#">
                                      <img src={linkedin_icon} alt="Linkedin" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="empfeedback">
                        <div className="container-fluid px-0">
                          <div className="team-info pb-3">
                            <div>
                              <div className="ttitle fw-bold">
                                Employee Feedback rating
                              </div>
                              <div className="teamsummary">
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the
                                industry's standard dummy text ever since the 1500s,
                              </div>
                            </div>
                          </div>
                          <div className="row g-4">
                            {/* Start of rating box */}
                            <div className="col-md-4 col-lg-3">
                              <div className="rating-card">
                                <div>
                                  <img
                                    src={empsatis}
                                    className="img-fluid"
                                    alt="Employee Satisfaction"
                                  />
                                </div>
                                <h5 className="mt-2">Employee Satisfaction</h5>
                                <p className="text-muted">
                                  Lorem Ipsum is simply dummy text of the printing
                                </p>
                                <div className="d-flex gap-2 align-items-center mt-3">
                                  <span className="stars">
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star-half-alt"></i>
                                  </span>
                                  <span className="rating-value">4.5/5</span>
                                </div>
                              </div>
                            </div>
                            {/* End of rating box */}
                            {/* Start of rating box */}
                            <div className="col-md-4 col-lg-3">
                              <div className="rating-card">
                                <div>
                                  <img
                                    src={compcul}
                                    className="img-fluid"
                                    alt="Company Culture"
                                  />
                                </div>
                                <h5 className="mt-2">Company Culture</h5>
                                <p className="text-muted">
                                  Lorem Ipsum is simply dummy text of the printing
                                </p>
                                <div className="d-flex gap-2 align-items-center mt-3">
                                  <span className="stars">
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star-half-alt"></i>
                                  </span>
                                  <span className="rating-value">4.5/5</span>
                                </div>
                              </div>
                            </div>
                            {/* End of rating box */}
                            {/* Start of rating box */}
                            <div className="col-md-4 col-lg-3">
                              <div className="rating-card">
                                <div>
                                  <img
                                    src={easywork}
                                    className="img-fluid"
                                    alt="Easy of Working"
                                  />
                                </div>
                                <h5 className="mt-2">Easy of Working</h5>
                                <p className="text-muted">
                                  Lorem Ipsum is simply dummy text of the printing
                                </p>
                                <div className="d-flex gap-2 align-items-center mt-3">
                                  <span className="stars">
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star-half-alt"></i>
                                  </span>
                                  <span className="rating-value">4.5/5</span>
                                </div>
                              </div>
                            </div>
                            {/* End of rating box */}
                            {/* Start of rating box */}
                            <div className="col-md-4 col-lg-3">
                              <div className="rating-card">
                                <div>
                                  <img
                                    src={wlifebalac}
                                    className="img-fluid"
                                    alt="Work life balance"
                                  />
                                </div>
                                <h5 className="mt-2">Work life balance</h5>
                                <p className="text-muted">
                                  Lorem Ipsum is simply dummy text of the printing
                                </p>
                                <div className="d-flex gap-2 align-items-center mt-3">
                                  <span className="stars">
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star-half-alt"></i>
                                  </span>
                                  <span className="rating-value">4.5/5</span>
                                </div>
                              </div>
                            </div>
                            {/* End of rating box */}
                            {/* Start of rating box */}
                            <div className="col-md-4 col-lg-3">
                              <div className="rating-card">
                                <div>
                                  <img
                                    src={topmang}
                                    className="img-fluid"
                                    alt="Top management"
                                  />
                                </div>
                                <h5 className="mt-2">Top management</h5>
                                <p className="text-muted">
                                  Lorem Ipsum is simply dummy text of the printing
                                </p>
                                <div className="d-flex gap-2 align-items-center mt-3">
                                  <span className="stars">
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star-half-alt"></i>
                                  </span>
                                  <span className="rating-value">4.5/5</span>
                                </div>
                              </div>
                            </div>
                            {/* End of rating box */}
                            {/* Start of rating box */}
                            <div className="col-md-4 col-lg-3">
                              <div className="rating-card">
                                <div>
                                  <img
                                    src={hrattitude}
                                    className="img-fluid"
                                    alt="HR attitude"
                                  />
                                </div>
                                <h5 className="mt-2">HR attitude</h5>
                                <p className="text-muted">
                                  Lorem Ipsum is simply dummy text of the printing
                                </p>
                                <div className="d-flex gap-2 align-items-center mt-3">
                                  <span className="stars">
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star-half-alt"></i>
                                  </span>
                                  <span className="rating-value">4.5/5</span>
                                </div>
                              </div>
                            </div>
                            {/* End of rating box */}
                            {/* Start of rating box */}
                            <div className="col-md-4 col-lg-3">
                              <div className="rating-card">
                                <div>
                                  <img
                                    src={ceorank}
                                    className="img-fluid"
                                    alt="CEO rating"
                                  />
                                </div>
                                <h5 className="mt-2">CEO rating</h5>
                                <p className="text-muted">
                                  Lorem Ipsum is simply dummy text of the printing
                                </p>
                                <div className="d-flex gap-2 align-items-center mt-3">
                                  <span className="stars">
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star"></i>
                                    <i className="fas fa-star-half-alt"></i>
                                  </span>
                                  <span className="rating-value">4.5/5</span>
                                </div>
                              </div>
                            </div>
                            {/* End of rating box */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </section>


    </div>
  );
};

export default CompanyProfile;